export default function securityCheck(message) {
  const securityCheckValue1 = 1 + Math.round(Math.random() * 9);
  const securityCheckValue2 = 1 + Math.round(Math.random() * 9);
  const securityCheckValue = securityCheckValue1 + securityCheckValue2;
  const securityCheckAnswer = window.prompt(
    `${message} \n\nSicherheitsabfrage: ${securityCheckValue1} + ${securityCheckValue2} = ?`,
  );

  return (
    String(securityCheckAnswer).replace(/\s/g, '') === String(securityCheckValue).replace(/\s/g, '')
  );
}
